module.exports = require("ajv/lib/refs/json-schema-draft-06.json");;